module.exports = __webpack_public_path__ + "static/img/screenshots-mac@2x.b67832e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/home/images/screenshots-mac@2x.png
// module id = KJxS
// module chunks = 26